import React, { useState, useCallback } from "react";
import { useNavigate } from 'react-router-dom';
import './Pricing.css';
import { useAuth } from '../AuthContext';

const Pricing = () => {
  const [isYearly, setIsYearly] = useState(false);
  const navigate = useNavigate();

  const { user, signInWithGoogle } = useAuth();

  const handleSubscribe = useCallback(async (planType) => {
    // Handle enterprise contact FIRST - no authentication required
    if (planType === 'enterprise') {
      window.location.href = 'mailto:support@leetengineerai.com';
      return;
    }

    // Handle free plan
    if (planType === 'free') {
      if (user) {
        // User is logged in, redirect to dashboard
        navigate('/dashboard');
      } else {
        // User needs to sign up for free plan - go to dashboard after auth
        signInWithGoogle('/dashboard');
      }
      return;
    }
    
    // Check if user is authenticated for paid plans (Standard)
    if (planType !== 'free' && !user) {
      // Store plan and redirect to sign-in
      // Store the intended plan in session storage for post-login redirect
      sessionStorage.setItem('pendingPlan', JSON.stringify({ planType, isYearly }));
      // Create the redirect URL with plan parameters
      const redirectUrl = `/payment-loading?plan=${planType}&yearly=${isYearly}`;
      signInWithGoogle(redirectUrl);
      return;
    }

    // Handle Standard plan - redirect to loading page
    if (planType === 'standard' && user) {
      // Redirect to payment loading page with plan parameters
      navigate(`/payment-loading?plan=${planType}&yearly=${isYearly}`);
      return;
    }
  }, [user, isYearly, signInWithGoogle, navigate]);

  return (
    <section className="get-started-section" id="pricing">
      <h2>Choose Your Plan & Get Hired Faster</h2>

      {/* Billing Toggle */}
      <div className="billing-toggle">
        <span className={!isYearly ? 'active' : ''}>Monthly</span>
        <label className="toggle-switch">
          <input
            type="checkbox"
            checked={isYearly}
            onChange={() => setIsYearly(!isYearly)}
          />
          <span className="slider"></span>
        </label>
        <span className={isYearly ? 'active' : ''}>Yearly</span>
        {isYearly && <span className="discount-badge">Save 20%</span>}
      </div>

      <div className="pricing-grid">
        <div className="pricing-item">
          <h3>Free Plan</h3>
          <p><strong>Free</strong></p>
          <ul>
            <li>3 technical interview questions</li>
            <li>1 ATS resume from scratch</li>
            <li>2 ATS job-tailored resume attempts</li>
            <li>Basic HR screening practice</li>
            <li>Basic answer suggestions</li>
          </ul>
          <button onClick={() => handleSubscribe('free')}>Start Free - No Credit Card</button>
        </div>
        <div className="pricing-item highlight">
          <h3>Standard Plan</h3>
          <p><strong>{isYearly ? '$100/year' : '$10/month'}</strong></p>
          <ul>
            <li>50 technical interview questions</li>
            <li>Unlimited ATS resumes from scratch</li>
            <li>50 ATS job-tailored resumes</li>
            <li>Full HR screening with AI performance analysis</li>
            <li>Personalized AI feedback & coaching</li>
            <li>Real-time answer analysis</li>
          </ul>
          <button 
            onClick={() => handleSubscribe('standard')}
          >
            Start Landing Offers
          </button>
        </div>
        <div className="pricing-item">
          <h3>Enterprise Plan</h3>
          <p><strong>Custom Pricing</strong></p>
          <ul>
            <li>Unlimited technical interview questions</li>
            <li>Unlimited ATS resume from scratch</li>
            <li>Unlimited ATS job-tailored resumes</li>
            <li>Unlimited HR screening & technical interviews</li>
            <li>Unlimited personalized answer generation</li>
            <li>Priority processing & support</li>
          </ul>
          <button onClick={() => handleSubscribe('enterprise')}>Get Custom Solution</button>
        </div>
      </div>
    </section>
  );
};

export default Pricing;